import amazon from "src/assets/images/amazon-logo.png";
import {KatIcon, KatNavigation, KatPopover} from "@amzn/katal-react";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {BETA_REGIONS, DEV_REGIONS, GAMMA_REGIONS, PROD_REGIONS} from "src/app/config/RegionUrlConfig";
import {Region, Stage} from "src/app/constant/Enums";
import UserInfoStore from "src/app/store/UserInfoStore";

const TopNavigation = () => {
    const regionRef = useRef<any>(null);
    const currentUrl = window.location.href;

    const [selectedValue, setSelectedValue] = useState<string | undefined>(() => {
        console.log("load select region");
        if (currentUrl.indexOf(Region.NA) != -1) {
            return Region.NA;
        }
        if (currentUrl.indexOf(Region.EU) != -1) {
            return Region.EU;
        }
        if (currentUrl.indexOf(Region.FE) != -1) {
            return Region.FE;
        }
    });

    const [regions, setRegions] = useState<Map<string, string>>(() => {
        console.log("init regions");
        return DEV_REGIONS
    });

    useEffect(() => {
        console.log("load regions");
        if (currentUrl.indexOf(Stage.BETA) != -1) {
            console.log("load beta regions");
            setRegions(BETA_REGIONS);
            return;
        }
        if (currentUrl.indexOf(Stage.GAMMA) != -1) {
            console.log("load gamma regions");
            setRegions(GAMMA_REGIONS);
            return;
        }
        if (currentUrl.indexOf(Stage.PROD) != -1) {
            console.log("load prod regions");
            setRegions(PROD_REGIONS);
            return;
        } else {
            console.log("load dev regions");
            setRegions(DEV_REGIONS);
            return;
        }
    }, []);

    const handleChange = () => {
        const region = regionRef.current.value;
        const url = regions.get(region) || '';
        setSelectedValue(region);
        window.location.href = url;
    };

    return (
        <KatNavigation slot="top" mode="horizontal" className={'nav-bg-color'}>
            <div style={{width: '20%', justifyContent: 'left', display: 'flex', height: '50px'}} data-testid='logo'>
                <div style={{alignContent: 'center', marginLeft: '10%', marginTop: "auto", marginBottom: "auto"}}>
                    <a href={"https://logistics.amazon.com/internal"} target="_blank">
                        <img src={amazon} alt="My Logo" className='logo'/>
                    </a>
                </div>
                <div style={{fontWeight: 'bold', fontSize: '20px', marginLeft: '20px', marginTop: 'auto',
                    marginBottom: 'auto'}} data-testid='title'>
                    Audit Enhancer Portal
                </div>
            </div>
            <div style={{width: '55%'}}>
            </div>
            <div style={{width: '20%', position: "relative", display: 'flex'}}>
                <div style={{width: '50%', gap: '12px', display: 'flex'}}>
                    <select value={selectedValue} onChange={handleChange} style={{width: '70%', height: '100%'}}
                            className='country' ref={regionRef} data-testid='region-select'>
                        {Array.from(regions.entries()).map(([key, value], index) => (
                            <option key={index} value={key}>
                                {key.toUpperCase()}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{width: '20%'}}>
                    <KatPopover position={'right'} triggerType={'hover'} katAriaBehavior={'tooltip'} data-testid='user-icon'>
                        <KatIcon name={'person'} slot={'trigger'}></KatIcon>
                        {UserInfoStore.value}
                    </KatPopover>
                </div>
            </div>
        </KatNavigation>
    );
}

export default TopNavigation;